"use client";

import React from "react";
import { LocaleLink } from "@/components/shared/LocaleLink";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal, Stagger, StaggerItem } from "@/components/shared/motion";
import { ArrowRight } from "lucide-react";

/**
 * eSIMCobra brutalist FAQ — replaces the shared glass FAQ. Hard-bordered
 * <details> accordion in the "Strike" system. Claim-safe copy. No glass.
 */
export default function FaqSection() {
  const { t } = useTranslations();
  const faqs = [
    { q: t("cobra.faq.q1", "How fast do I get my eSIM?"), a: t("cobra.faq.a1", "Your QR code is emailed instantly after checkout. Install it on Wi-Fi and switch on data when you land.") },
    { q: t("cobra.faq.q2", "Will it work on my phone?"), a: t("cobra.faq.a2", "Most phones from 2018 on support eSIM (iPhone XS+, Galaxy S20+, Pixel 3+). Run the compatibility checker to confirm.") },
    { q: t("cobra.faq.q3", "Do I keep my number?"), a: t("cobra.faq.a3", "Yes. The eSIM is data-only and runs alongside your home SIM, so calls, texts and WhatsApp keep working.") },
    { q: t("cobra.faq.q4", "Can I use it in more than one country?"), a: t("cobra.faq.a4", "Pick a regional or global plan for multi-country trips; country plans cover a single destination.") },
    { q: t("cobra.faq.q5", "Is checkout secure?"), a: t("cobra.faq.a5", "Payment is encrypted and the eSIM is delivered to your email the moment payment clears.") },
  ];

  return (
    <section className="container mx-auto px-4 py-14">
      <Reveal as="h2" y={18} duration={0.4} className="display-xl text-3xl sm:text-4xl mb-6">{t("cobra.faq.title", "Quick answers")}</Reveal>
      <Stagger as="div" staggerChildren={0.05} className="space-y-3 max-w-3xl">
        {faqs.map(({ q, a }) => (
          <StaggerItem key={q} as="div" y={16} duration={0.32}>
            <details className="group border-2 border-foreground bg-card p-4 shadow-[4px_4px_0_0_hsl(var(--foreground))]">
              <summary className="flex items-center justify-between cursor-pointer font-bold uppercase tracking-tight text-foreground list-none">
                {q}<span className="text-primary group-open:rotate-45 transition-transform text-2xl leading-none">+</span>
              </summary>
              <p className="mt-2 text-sm font-medium normal-case text-foreground/80">{a}</p>
            </details>
          </StaggerItem>
        ))}
      </Stagger>
      <LocaleLink href="/contact-us/" className="mt-5 inline-flex items-center gap-1.5 font-bold uppercase text-primary hover:underline">
        {t("cobra.faq.more", "More help")} <ArrowRight className="w-4 h-4" />
      </LocaleLink>
    </section>
  );
}
